(function () {
  var ratingsPromise;

  function loadRatings() {
    if (ratingsPromise) return ratingsPromise;
    if (window.__lxProductReviewsData) {
      ratingsPromise = window.__lxProductReviewsData;
      return ratingsPromise;
    }
    if (!window.LX_PRODUCT_REVIEWS_URL) {
      return Promise.reject(new Error('Product review data URL is unavailable'));
    }

    ratingsPromise = fetch(window.LX_PRODUCT_REVIEWS_URL, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load product review ratings');
      return response.json();
    });
    window.__lxProductReviewsData = ratingsPromise;

    return ratingsPromise;
  }

  function pendingRatings(root) {
    var nodes = [];
    if (root.matches && root.matches('[data-lx-rating-source]:not([data-lx-rating-initialized])')) {
      nodes.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-lx-rating-source]:not([data-lx-rating-initialized])').forEach(function (node) {
        nodes.push(node);
      });
    }
    return nodes;
  }

  function hydrate(root) {
    var ratings = pendingRatings(root);
    if (!ratings.length) return;

    ratings.forEach(function (rating) {
      rating.setAttribute('data-lx-rating-initialized', 'true');
    });

    loadRatings()
      .then(function (products) {
        ratings.forEach(function (rating) {
          show(rating, products[rating.getAttribute('data-product-handle')]);
        });
      })
      .catch(function () {
        ratings.forEach(function (rating) {
          rating.removeAttribute('data-lx-rating-initialized');
          show(rating, null);
        });
      });
  }

  // Listing rating + the store's own review-app ratings, combined (weighted).
  function show(rating, product) {
    var storeCount = Number(rating.getAttribute('data-store-count')) || 0;
    var storeAverage = Number(rating.getAttribute('data-store-avg')) || 0;
    if (storeCount <= 0 || storeAverage <= 0) {
      storeCount = 0;
      storeAverage = 0;
    }
    var hasSource = product && Number(product.average) > 0 && Number(product.total) > 0;
    var total;
    var average;

    if (hasSource) {
      total = Number(product.total) + storeCount;
      average = (Number(product.average) * Number(product.total) + storeAverage * storeCount) / total;
    } else if (storeCount > 0) {
      total = storeCount;
      average = storeAverage;
    } else {
      return;
    }

    var stars = rating.querySelector('.lx-rating__stars');
    var fill = rating.querySelector('.lx-rating__fill');

    if (stars) stars.setAttribute('aria-label', average.toFixed(1) + ' out of 5 stars');
    if (fill) fill.style.width = Math.max(0, Math.min(100, average * 20)) + '%';
    rating.querySelector('.lx-rating__num').textContent = average.toFixed(1);
    rating.querySelector('.lx-rating__count').textContent =
      '(' + total + ' ' + (rating.getAttribute('data-count-noun') || 'review') + (total === 1 ? '' : 's') + ')';
    rating.hidden = false;
  }

  function start() {
    hydrate(document);

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) hydrate(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
